import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IBrand } from '../../../components/models/models'
import { IBrandNoticeRequest } from '../models/models'

export class AddBrandNoticeApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/brand/addBrandNotice',
      requesterInfo,
    })
  }

  public async addBrand(request: IBrandNoticeRequest): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
